import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, Platform } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';
import { register } from 'swiper/element/bundle';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Api } from 'src/smoothr-web-app-core/api/api';

//this is to initialize libraries and services
register();
Api;

declare var cookieConsentData: any;
declare var cookieConsentCallback: any;

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	standalone: false,
})
export class AppComponent implements OnInit {
	static largeScreen = false;
	static analyticsEnabled = false;
	static langLocalStorageKey = 'langOfApp';

	destroyRef = inject(DestroyRef);
	private route = inject(ActivatedRoute);
	private alertCtrl = inject(AlertController);
	private snackbarCtrl = inject(MatSnackBar);
	private router = inject(Router);
	private analytics = inject(AngularFireAnalytics);
	private platform = inject(Platform);
	private translate = inject(TranslateService);
	private swUpdate = inject(SwUpdate);

	constructor() {
		console.log(environment.customerGroup + ' ' + environment.version);

		const favIcon: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		favIcon.type = 'image/x-icon';
		favIcon.rel = 'shortcut icon';
		favIcon.href = '../assets/versel/logo_icon.svg';
		document.getElementsByTagName('head')[0].appendChild(favIcon);
		this.translate.get('index.title.' + environment.customerGroup).subscribe(title => {
			document.title = title;
		});

		const languageValue = localStorage.getItem(AppComponent.langLocalStorageKey);

		if (languageValue) {
			this.translate.setDefaultLang(languageValue);
			this.translate.use(languageValue);
		} else {
			this.translate.setDefaultLang('en');
			this.translate.use('en');
		}

		this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem(AppComponent.langLocalStorageKey, languageChanged.lang);
		});

		this.initCookieConsent();
	}

	ngOnInit() {}

	async handleCookieConsent() {
		console.log('handleCookieConsent()');
		AppComponent.analyticsEnabled = cookieConsentData.targeting;

		await this.setAnalyticsEnabled(cookieConsentData.targeting);
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}
	loadHotjarScript() {
		console.log('Load Hotjar');

		// try {
		// 	setTimeout(() => {
		// 		const script = document.createElement('script');
		// 		script.innerHTML = `
		// 		  (function(h,o,t,j,a,r){
		// 			  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
		// 			  h._hjSettings={hjid:${environment.hjid},hjsv:6};
		// 			  a=o.getElementsByTagName('head')[0];
		// 			  r=o.createElement('script');r.async=1;
		// 			  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
		// 			  a.appendChild(r);
		// 		  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
		// 		`;
		// 		document.head.appendChild(script);
		// 	}, 3000);
		// } catch (e) {
		// 	console.log(e);
		// }
	}
	private async initCookieConsent() {
		const onContentLoaded = async () => {
			// просто ініціалізація чи лог
			console.log('Cookie consent data initialized:', cookieConsentData);
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', onContentLoaded);
		} else {
			await onContentLoaded();
		}

		cookieConsentCallback = async () => {
			console.log('Cookie consent callback triggered');
			await this.handleCookieConsent();
		};

		await this.handleCookieConsent();
	}
}
